/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Hide/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaVisibilityOff from 'DesignSystem/Svgs/TysiaVisibilityOff/index'



/** @type {import('Simple/types.js').View} */
export default function Hide({
  children,
  viewPath = "/App/Auth/SignIn/Credentials/Password/VisibilityAction/Hide"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaVisibilityOff
  viewPath={`${viewPath}/TysiaVisibilityOff`}
 fill2={dtColorsNeutral400}
/>
{children}
</React.Fragment>)
}